// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const IndentIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 0a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-.67a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1z"
      clipRule="evenodd"
    />
  </svg>,
  "Indent",
);
export default IndentIcon;
